import { Global } from "@emotion/react";

export default function GeorgiaFont() {
  return (
    <Global
      styles={`
      @font-face {
        font-family: 'Georgia';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/georgia/bold.woff2') format('woff2'), url('/fonts/georgia/bold.woff') format('woff');
      }
      @font-face {
        font-family: 'Georgia';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/georgia/normal.woff2') format('woff2'), url('/fonts/georgia/normal.woff') format('woff');
      }
      `}
    />
  );
}
